import { atom } from "jotai";
import UserPublicationPinRecord from "models/view-models/user-publication-pin-record";

const PinnedPublicationsAtoms = atom<Array<UserPublicationPinRecord>>([]);

export default PinnedPublicationsAtoms;
